import styled from 'styled-components'
import { Stack } from '@mui/material'

export const DisplayHeaderContainerStyles = styled(Stack)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: -webkit-fill-available;
`
